import { useI18n } from "@alife/panda-i18n";
import { motion } from "framer-motion";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { DOMAIN_MAP } from "src/utils/const";
import styled from "styled-components";
const Container = motion.custom(styled.div `
  position: fixed;
  bottom: 80px;
  right: 10px;
  width: 64px;
  height: 64px;
  cursor: pointer;
  background: url(https://img.alicdn.com/imgextra/i1/O1CN01OJJZor1wZ4DPIjVSE_!!6000000006321-2-tps-124-124.png);
  background-size: contain;
  -webkit-tap-highlight-color: transparent;
`);
const DragConstraints = styled.div `
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 74px;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;
export default forwardRef(function Entry(props, ref) {
    const $i18n = useI18n();
    const { env = 'prod', userSystem = 'cbc' } = props;
    const dragConstraintsRef = useRef(null);
    const dragTargetRef = useRef(null);
    const entryRef = useRef(null);
    useImperativeHandle(ref, () => ({
        getPosition() {
            return entryRef.current;
        },
        getBoundingClientRect() {
            return dragTargetRef.current?.getBoundingClientRect?.();
        }
    }));
    const onClick = () => {
        const accountTypeDomainMap = DOMAIN_MAP[userSystem];
        const urlPrefix = accountTypeDomainMap?.[env];
        if (!urlPrefix) {
            return;
        }
        const url = `${urlPrefix}?code=${props.panelCode}&lang=${$i18n.getLang()}`;
        if (window.dd && window.dd.env?.platform !== 'notInDingTalk') {
            window.dd?.biz?.util?.openLink({
                url, //要打开链接的地址
            });
        }
        else {
            location.href = url;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DragConstraints, { ref: dragConstraintsRef }),
        React.createElement(Container, { ref: dragTargetRef, style: {
                bottom: 80,
                ...props.style
            }, transformTemplate: ({ x, y }) => {
                // console.log('transformTemplate', x, y);
                entryRef.current = {
                    x: parseInt(x, 10),
                    y: parseInt(y, 10),
                };
                // console.log('entryRef.current', entryRef.current);
                return ` translateX(${x || 0}) translateY(${y || 0})`;
            }, dragConstraints: dragConstraintsRef, dragTransition: { timeConstant: 100 }, positionTransition: false, dragging: false, onClick: onClick, drag: true })));
});
